<svg class="profile-back size-{{imageSize}}"
     viewBox="0 0 100 100"
     width="100"
     height="100"
     xmlns="http://www.w3.org/2000/svg">
    <g>
        <ellipse cx="50"
                 cy="50"
                 rx="50"
                 ry="50" />
        <text x="50%"
              y="50%">{{person!.initials}}</text>
    </g>
</svg>